import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { ServiceBase } from '../../shared/base/service-base';

import { User } from './user';

@Injectable()
export class UserService extends ServiceBase<User> {
  constructor(db: AngularFireDatabase) {
    super(db, '/users');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/shared/user.service.ts